
import React, { useState } from "react";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Input } from "@/components/ui/input";
import { PRICING_OPTIONS } from "@/models/agent-form";

interface PricingSelectorProps {
  value: "free" | "paid";
  price?: number;
  onPricingChange: (value: "free" | "paid") => void;
  onPriceChange: (value: number | undefined) => void;
  error?: string;
  priceError?: string;
}

const PricingSelector: React.FC<PricingSelectorProps> = ({ 
  value, 
  price, 
  onPricingChange, 
  onPriceChange, 
  error, 
  priceError 
}) => {
  return (
    <div className="space-y-4">
      <div>
        <Label>Pricing Model</Label>
        <RadioGroup 
          value={value} 
          onValueChange={(val) => onPricingChange(val as "free" | "paid")} 
          className="flex flex-col space-y-2 mt-2"
        >
          {PRICING_OPTIONS.map(option => (
            <div key={option.value} className="flex items-center space-x-2">
              <RadioGroupItem value={option.value} id={option.value} />
              <Label htmlFor={option.value} className="cursor-pointer">{option.label}</Label>
            </div>
          ))}
        </RadioGroup>
        {error && <p className="text-sm text-destructive mt-1">{error}</p>}
      </div>
      
      {value === "paid" && (
        <div>
          <Label htmlFor="price">Price (USD)</Label>
          <div className="relative mt-1">
            <span className="absolute left-3 top-2.5 text-muted-foreground">$</span>
            <Input
              id="price"
              type="number"
              min="0"
              step="0.01"
              placeholder="10.00"
              value={price || ""}
              onChange={(e) => onPriceChange(e.target.value ? parseFloat(e.target.value) : undefined)}
              className="pl-7"
            />
          </div>
          {priceError && <p className="text-sm text-destructive mt-1">{priceError}</p>}
        </div>
      )}
    </div>
  );
};

export default PricingSelector;
